import { useQuery } from '@tanstack/react-query';
import axios from '@/lib/v2/axios';

import type { Title } from '@/types/title';

export const useTitles = (type?: 'user' | 'community') => {
  return useQuery({
    queryKey: ['user-titles', type],
    queryFn: async () => {
      const params = type ? `?type=${type}` : '';
      const response = await axios.get(`/api/v2/user-titles${params}`);
      return response.data.data as Title[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useUserTitles = () => useTitles('user');
export const useCommunityTitles = () => useTitles('community');
